import React from 'react'
import { LoadingPlaceholder } from '@mobi/component-library/Misc/LoadingPlaceholder'
import {
  isDogsFormData,
  isRacesFormData,
  isTrotsFormData,
  useRaceFormData,
} from '@core/Areas/Racing/Hooks/useRaceFormData'
import { Dogs, Races, Trots } from './Components'

export const Form = React.memo<{
  meetingId: string
  meetingDate: Date
  raceNumber: number
  starterNumber: number
  starterName?: string
  courseCondition?: string
}>(({ meetingId, meetingDate, raceNumber, starterNumber, starterName, courseCondition }) => {
  const { isLoading, isError, data } = useRaceFormData({ meetingDate, meetingId, raceNumber })

  if (isLoading)
    return <LoadingPlaceholder testId='form-loading-placeholder' width='100%' height='20rem' />

  if (!data || isError) return null

  if (isRacesFormData(data)) {
    return (
      <Races
        form={data.Forms.find(form => form.StarterNumber === starterNumber)}
        courseCondition={courseCondition}
        starterName={starterName}
      />
    )
  }

  if (isTrotsFormData(data)) {
    return (
      <Trots
        form={data.Forms.find(form => form.StarterNumber === starterNumber)}
        starterName={starterName}
      />
    )
  }

  if (isDogsFormData(data)) {
    return (
      <Dogs
        form={data.Forms.find(form => form.StarterNumber === starterNumber)}
        starterName={starterName}
      />
    )
  }

  return null
})
